
const DraggableZones = {
  Top: 'top',
  Bottom: 'bottom',
};

export default {
  name: 'BbResizableContainer',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    minHeight: {
      type: String,
      default: 'auto',
    },
    maxHeight: {
      type: String,
      default: '100%',
    },
    initialHeight: {
      type: String,
      default: 'auto',
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    draggableSides: {
      type: Array,
      default: () => ([DraggableZones.Bottom]),
    },
    topDraggableElHeight: {
      type: String,
      default: '0px',
    },
    bottomDraggableElHeight: {
      type: String,
      default: '0px',
    },
  },
  data() {
    return {
      resizedHeight: null,
      startY: null,
      startHeight: null,
      parentElementHeight: null,
    };
  },
  computed: {
    computedStyles() {
      return {
        width: this.width,
        minHeight: this.computedMinHeight,
        maxHeight: this.maxHeight,
        height: this.computedHeight,
      };
    },
    computedMinHeight() {
      let resultMinHeight = parseInt(this.minHeightInPixels, 10);
      const draggableElementsHeight = parseInt(this.topDraggableElHeight, 10)
      + parseInt(this.bottomDraggableElHeight, 10);
      if (this.minHeight === 'auto' || (draggableElementsHeight > parseInt(this.minHeightInPixels, 10))) {
        resultMinHeight = draggableElementsHeight;
      }
      return `${resultMinHeight}px`;
    },
    initialHeightInPixels() {
      return this.getHeightInPixels(this.initialHeight);
    },
    minHeightInPixels() {
      return this.getHeightInPixels(this.minHeight);
    },
    maxHeightInPixels() {
      return this.getHeightInPixels(this.maxHeight);
    },
    computedHeight() {
      let height;
      if (this.initialHeight && !this.resizedHeight) {
        height = this.initialHeightInPixels;
      }
      if (this.resizedHeight) {
        height = this.resizedHeight;
      }
      return height;
    },
    isTopDraggable() {
      return this.draggableSides.includes(DraggableZones.Top);
    },
    isBottomDraggable() {
      return this.draggableSides.includes(DraggableZones.Bottom);
    },
  },
  watch: {
    isCollapsed(val) {
      if (val) {
        this.resizedHeight = this.computedMinHeight;
        this.handleResize();
      }
      if (!val && parseInt(this.resizedHeight, 10) === parseInt(this.computedMinHeight, 10)) {
        this.resizedHeight = this.initialHeightInPixels;
        this.handleResize();
      }
    },
  },
  methods: {
    percentsToPixels(value) {
      return parseInt(this.parentElementHeight, 10) * value;
    },
    getHeightInPixels(value) {
      return value.includes('%') ? `${this.percentsToPixels(parseInt(value, 10) / 100)}px` : value;
    },
    initTopDrag(e) {
      this.startHeight = parseInt(document.defaultView.getComputedStyle(this.$refs.resizableContainer).height, 10);
      this.startY = e.clientY;
      this.$refs.resizableContainer.parentElement.addEventListener('mousemove', this.doTopDrag, false);
      this.$refs.resizableContainer.parentElement.addEventListener('mouseup', this.stopTopDrag, true);
    },
    initBottomDrag(e) {
      this.startHeight = parseInt(document.defaultView.getComputedStyle(this.$refs.resizableContainer).height, 10);
      this.startY = e.clientY;
      this.$refs.resizableContainer.parentElement.addEventListener('mousemove', this.doBottomDrag, false);
      this.$refs.resizableContainer.parentElement.addEventListener('mouseup', this.stopBottomDrag, true);
    },
    doTopDrag(e) {
      const updatedHeight = this.startHeight - e.clientY + this.startY;
      if (updatedHeight <= parseInt(this.maxHeightInPixels, 10)
        && updatedHeight >= parseInt(this.computedMinHeight, 10)) {
        this.resizedHeight = `${this.startHeight - e.clientY + this.startY}px`;
        this.handleResize();
      }
    },
    doBottomDrag(e) {
      const updatedHeight = this.startHeight + e.clientY - this.startY;
      if (updatedHeight <= parseInt(this.maxHeightInPixels, 10)
        && updatedHeight >= parseInt(this.computedMinHeight, 10)) {
        this.resizedHeight = `${this.startHeight + e.clientY - this.startY}px`;
        this.handleResize();
      }
    },
    stopTopDrag() {
      this.$refs.resizableContainer.parentElement.removeEventListener('mousemove', this.doTopDrag, false);
      this.$refs.resizableContainer.parentElement.removeEventListener('mouseup', this.stopTopDrag, false);
    },
    stopBottomDrag() {
      this.$refs.resizableContainer.parentElement.removeEventListener('mousemove', this.doBottomDrag, false);
      this.$refs.resizableContainer.parentElement.removeEventListener('mouseup', this.stopBottomDrag, false);
    },
    handleResize() {
      this.$emit('container-resize', this.computedHeight);
    },
  },
  mounted() {
    this.parentElementHeight = document
      .defaultView
      .getComputedStyle(this.$refs.resizableContainer.parentElement)
      .height;
    this.$emit('container-resize', this.computedHeight);
    if (this.isCollapsed) {
      this.resizedHeight = this.computedMinHeight;
      this.handleResize();
    }
    this.draggableSides.forEach((element) => {
      const eventListenerHandlerName = `init${element[0].toUpperCase()}${element.slice(1)}Drag`;
      this.$refs[`${element}Draggable`]
        .addEventListener('mousedown', this[eventListenerHandlerName], false);
    });
  },
  beforeDestroy() {
    this.draggableSides.forEach((element) => {
      const eventListenerHandlerName = `init${element[0].toUpperCase()}${element.slice(1)}Drag`;
      this.$refs[`${element}Draggable`]
        .removeEventListener('mousedown', this[eventListenerHandlerName], false);
    });
  },
};
